import './style.css';
import myImagen1 from './img/tranquilidad.jpeg';
import tituloCafe from '../cafeRural/img-video/titulo-transparente.png'
import { createSearchParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {animateScroll as scroll} from 'react-scroll';
import axios from 'axios';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AyudaDomicilio from '../../img/Ayuda a Domicilio.png'
import Fisioterapia from '../../img/Fisioterapia.png'
import Podologia from '../../img/Podología.png'
import Residencia from '../../img/Residencia.png'
import CentroDia from '../../img/Centro de dia.png'
import basico from '../clubCuidatia/img-video/BASICO.png'
import premium from '../clubCuidatia/img-video/PREMIUM.png'
import todoIncluido from '../clubCuidatia/img-video/TODO-INCLUIDO.png'

function CasosUso({nombre, numCasoUso}) {
    switch (numCasoUso) {
        case 0:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className="bloque-abajo" id="busca">
                    <ul>
                        <h2>Usuario</h2>
                        <li>Ayuda a buscar los servicios más cercanos disponibles.</li>
                        <li>Permite encontrar servicios a precios económicos.</li>
                    </ul>
                    <ul>
                        <h2>Empresa</h2>
                        <li>Localiza los servicios disponibles que estén próximos a la localización de la empresa.</li>
                        <li>Permite comparar precios de diferentes servicios para ahorrar costes.</li>
                    </ul>
                </div>
                </div>
                </div>
            );
        case 1:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className="bloque-abajo" id="servicios">
                    <ul>
                        <h2>Usuario</h2>
                        <li>Proporciona información sobre los servicios que más puntuación tienen.</li>
                        <li>Muestra los servicios más populares y buscados, aquello que todo el mundo utiliza.</li>
                    </ul>
                    <ul>
                        <h2>Empresa</h2>
                        <li>Permite a la empresa obtener información acerca de los servicios más utilizados de la plataforma.</li>
                        <li>Gracias a esto, la empresa puede obtener información sobre los mejroes servicios ofrecidos.</li>
                    </ul>
                </div>
                </div>
                </div>
            );
        case 2:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className='bloque-abajo' id='ia'>
                    <ul>
                        <h2>Usuario</h2>
                        <li>Busca alternativas a servicios que el usuario solicite.</li>
                    </ul>
                    <ul>
                        <h2>Empresa</h2>
                        <li>Proporciona puntos de vista y valoraciones que la empresa puede que no contemplase.</li>
                    </ul>
                </div>
                </div>
                </div>
            );
        case 3:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className='bloque-abajo' id='compania'>
                <ul>
                    <h2>Usuario</h2>
                    <li>Aquellas personas que se sientan solas, les da cierta compañía.</li>
                    <li>Resuelve dudas sencillas y frecuentes que el apartado de ayuda no contemple.</li>
                </ul>
                <ul>
                    <h2>Empresa</h2>
                    <li>Se beneficia de la misma manera que un usuario.</li>
                </ul>
            </div>
            </div>
            </div>
            );
        case 4:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className='bloque-abajo' id='posicion'>
                    <ul>
                        <h2>Usuario</h2>
                        <li>El usuario promedio puede conocer cuáles son las empresas que ofrecen los mejores servicios.</li>
                    </ul>
                    <ul>
                        <h2>Empresa</h2>
                        <li>Ayuda a las empresas dando visibilidad a los servicios que pueden ofrecer o solicitar.</li>
                    </ul>
                </div>
                </div>
                </div>
            );
        case 5:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className='bloque-abajo' id='usuarios'>
                    <ul>
                        <h2>Usuario</h2>
                        <li>Sirve como recordatorio sobre las citas que tiene reservadas.</li>
                        <li>Permite gestionar su calendario según los servicios contratados.</li>
                    </ul>
                    <ul>
                        <h2>Empresa</h2>
                        <li>Permite reservar ciertos servicios o citas con la empresa que lo proporciona.</li>
                        <li>Al igual que a los usuarios, les ayuda a optimizar el calendario.</li>
                    </ul>
                </div>
                </div>
                </div>
            );
        default:
            return (
                <div className="container">
                <div className="section-title">
                    <h2>Casos de Uso: {nombre}</h2>
                </div>
                <div className='contenido-cuidatia'>
                <div className="bloque-abajo" id="busca">
                    <ul>
                        <h2>Usuario</h2>
                        <li>Buscar los servicios más cercanos disponibles.</li>
                        <li>Encontrar servicios a precios económicos.</li>
                    </ul>
                    <ul>
                        <h2>Empresa</h2>
                        <li>Localiza los servicios disponibles que estén próximos a la localización de la empresa.</li>
                        <li>Comparar precios de diferentes servicios para ahorrar costes.</li>
                    </ul>
                </div>
                </div>
                </div>
            );
    }
    
}

export const SectionOne = () => {
    const navigate = useNavigate()
    const [categorias, setCategorias] = useState([]);
    const [recomendaciones, setRecomendaciones] = useState([]);
    
    const imagenes = [
        {
            'nombre': 'Ayuda a domicilio',
            'imagen': AyudaDomicilio
        },
        {
            'nombre': 'Fisioterapia',
            'imagen': Fisioterapia
        },
        {
            'nombre': 'Podología',
            'imagen': Podologia
        },
        {
            'nombre': 'Residencia',
            'imagen': Residencia
        },
        {
            'nombre': 'Centro de día',
            'imagen': CentroDia
        }
    ]

    const getCategorias = async () => {
        await axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		})
			.then((response) => {
				let listaAxu = [];
				response.data.slice(0,5).map((categoria) => {
					listaAxu.push({...categoria});
				});
				setCategorias(listaAxu);
			})
			.catch((error) => {
				console.log(error);
			});
    }

    const getRecomendaciones = async () => {
        const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/");
        const empresas = response.data;

        // Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
        const empresasConImagenes = await Promise.all(
            empresas.map(async empresa => {
            try {

                const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
                responseType: "blob"
                });
                const imagenURL = URL.createObjectURL(imagenResponse.data);
                // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
                return { ...empresa, img: imagenURL };
            } catch (error) {
                return { ...empresa, img: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images" };
            }
            })
        );
        console.log('empresasConImagenes', empresasConImagenes)
        setRecomendaciones(empresasConImagenes);
    }

    useEffect(() => {
        getCategorias();
        getRecomendaciones();
    }, []);

    const abrirPerfilEmpresa = (id) => {    
            navigate('/perfilAgencia/' + id);
        };

	return (
		<>
            <section className="callToAction">
                <div className="container-cta relative">
                    <div className="container-items flex flex-wrap">
                        <div className="">
                            <span className="h3-about block mb-4 text-base font-medium text-white ">
                                Todo lo que buscas, en un solo lugar
                            </span>
                            <h2 className="text-uppercase mb-6 text-3xl font-bold leading-tight text-white sm:mb-8 sm:text-[40px]/[48px] lg:mb-0">
                                <span className="xs:block h2-about">Explora cuidados a domicilio cerca de ti.</span>
                            </h2>
                        </div>
                        <div className="px-4 mt-2 lg:w-1/2">
                            <div className="flex flex-wrap lg:justify-end">
                                <div className="btn btn-cta btn-lg"
                                    onClick={() => {
                                        navigate('#buscador')
                                    }}
                                >
                                    BUSCAR SERVICIOS
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <span className="absolute top-0 left-0 z-[-1]">
                            <svg
                            width="189"
                            height="162"
                            viewBox="0 0 189 162"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <ellipse
                                cx="16"
                                cy="-16.5"
                                rx="173"
                                ry="178.5"
                                transform="rotate(180 16 -16.5)"
                                fill="url(#paint0_linear)"
                            />
                            <defs>
                                <linearGradient
                                id="paint0_linear"
                                x1="-157"
                                y1="-107.754"
                                x2="98.5011"
                                y2="-106.425"
                                gradientUnits="userSpaceOnUse"
                                >
                                <stop stop-color="white" stop-opacity="0.15" />
                                <stop offset="1" stop-color="white" stop-opacity="0" />
                                </linearGradient>
                            </defs>
                            </svg>
                        </span>
                        <span className="absolute bottom-0 right-0 z-[-1]">
                            <svg
                            width="191"
                            height="208"
                            viewBox="0 0 191 208"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <ellipse
                                cx="173"
                                cy="178.5"
                                rx="173"
                                ry="178.5"
                                fill="url(#paint0_linear)"
                            />
                            <defs>
                                <linearGradient
                                id="paint0_linear"
                                x1="-3.27832e-05"
                                y1="87.2457"
                                x2="255.501"
                                y2="88.5747"
                                gradientUnits="userSpaceOnUse"
                                >
                                <stop stop-color="white" stop-opacity="0.15" />
                                <stop offset="1" stop-color="white" stop-opacity="0" />
                                </linearGradient>
                            </defs>
                            </svg>
                        </span>
                    </div>
                </div>
            </section>

			{/* <section id='nuestro-metodo' className="metodo">
                <div className="container">
                    <div className="section-title">
                        <h2>Nuestro método</h2>
                    </div>
                    <div className='main-metodo'>
                        <div className='titulo-pasos'>
                            <h2>En <b>Cuidatia</b>, hemos desarrollado un conjunto de tecnologías únicas y avanzadas para transformar y 
                            mejorar la experiencia de cuidado de las personas en todas las fases de la vida.</h2>
                        </div>
                        < style={{width:'100%'}}>
                            <div className='metodo-arriba'>
                                <div className='busca item'>
                                    <h1>🌍</h1>
                                    <h3>Buscador y Geolocalizador</h3>
                                    <p>Encuentra y compara servicios en tu área según ubicación y precio.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(0); setNombre('Búsqueda y Geolocalizador')}}>
								        MAS INFORMACION
							        </div>
                                </div>
                                <div className='servicios item'>
                                    <h1>⭐</h1>
                                    <h3>Recomendación de Servicios</h3>
                                    <p className='centro'>Sugerencias de los servicios más buscados y mejor valorados.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(1); setNombre('Recomendación de Servicios')}}>
								        MAS INFORMACION
							        </div>
                                </div>
                                <div className='ia item'>
                                    <h1>🤖</h1>
                                    <h3>Asesoramiento con IA</h3>
                                    <p className='centro'>Recibe recomendaciones personalizadas basadas en las necesidades de cualquier usuario.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(2); setNombre('Asesoramiento con IA')}}>
								        MAS INFORMACION
							        </div>
                                </div>
                                <div className='compania item'>
                                    <h1>💬</h1>
                                    <h3>Compañía Virtual</h3>
                                    <p className='centro'>Conversa con “MARÍA” en cualquier momento del día y siéntete acompañado siempre.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(3); setNombre('Compañía Virtual')}}>
								        MAS INFORMACION
							        </div>
                                </div>
                                <div className='posicion item'>
                                    <h1>📈</h1>
                                    <h3>Mejora del Posicionamiento</h3>
                                    <p className='centro'>Herramientas para aumentar la visibilidad de las empresas de cuidado.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(4); setNombre('Mejora del Posicionamiento')}}>
								        MAS INFORMACION
							        </div>
                                </div>
                                <div className='usuarios item'>
                                    <h1>📅</h1>
                                    <h3>Gestión de Agenda y Citas</h3>
                                    <p className='centro'>Optimiza la organización de servicios y citas para empresas.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(5); setNombre('Gestión de Agenda y Citas')}}>
								        MAS INFORMACION
							        </div>
                                </div>
                            </div>
                            {/* <div className='metodo-abajo scroll-indicators'>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                            </div> */}
                        {/* </div>
                    </div>                     
                </div>
            </section> */}

            <section className='py-5'>
                <div className="container">
                    <div className="titulo-pasos">
                        <h2 className='h2-about text-uppercase'>Categorías populares</h2>
                    </div>
                    <div className='text-center'>
                        <p className='h3-about'>Explora nuestras categorías más populares y encuentra lo que necesitas.</p>
                    </div>
                    <div className="container-categorias d-flex res-cate justify-content-between text-center">
                        {categorias?.map((categoria) => (
                            <div className="imagen-categoria p-5" key={categoria.id}>
                            {imagenes
                                .filter((imagen) => imagen.nombre === categoria.nombre)
                                .map((imagen) => (
                                    <img className='rounded-pill downgrade' key={imagen.nombre} src={imagen.imagen} alt={categoria.nombre} 
                                        onClick={
                                            () => {
                                                scroll.scrollToTop();
                                                navigate({pathname: 'busqueda',
                                                    search: '?' + createSearchParams({q:categoria.nombre, lugar:'0', categoria:categoria.id})
                                                })
                                            }
                                        }
                                    />
                                ))
                            }
                                <strong>{categoria.nombre}</strong>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* <section id='por-que-cuidatia' className='about'>
                <div className="container">
                    <div className="section-title">
                        <h2>Por qué CUIDATIA</h2>
                    </div>
                        <div className='contenido-cuidatia'>
                            <div className='titulo-pasos'>
                                <h2>Cuando eliges <b>Cuidatia</b> tendrás la libertad de elefir tus cuidados. 
                                Con los mejores profesionales, seguridad, recomendaciones y sobre todo, 
                                fácil de hacer.
                                </h2>
                            </div>
                            <div className='bloque-abajo'>
                                <ul>
                                    <li>Todas las garantias de compra segura.</li>
                                    <li>La garantía de elegir profesionales cualificados y certificados.</li>
                                    <li>Es muy fácil de contratar los servicios. Solo 3 pasos: <b>BUSCA</b>, <b>ELIGE</b> y <b>RESERVA</b>. </li>
                                </ul>
                                <ul>
                                    <li>Garantía de seguridad. Política de Privacidad.</li>
                                    <li>Soporte 24 horas en caso de tener dudas.</li>
                                    <li>Uso de IA para ofrecer recomendaciones personalizadas y asistencia continua.</li>
                                    <li>Valoraciones verificables de otros usuarios.</li>
                                </ul>
                            </div>
                        </div>
                </div>
            </section> */}

            <section className='py-5' style={{backgroundColor:'rgba(243, 243, 243, 0.38)'}}>
                <div className="container">
                    <div className="titulo-pasos">
                        <h2 className='h2-about text-uppercase'>Servicios recomendados</h2>
                    </div>
                    <div className="container-categorias m-auto px-3 d-flex flex-wrap justify-content-between">
                        {
                            recomendaciones?.slice(0,3).map((recomendacion) => (
                                // <Card
                                //     className="rounded-2 m-2 responsivo"
                                //     onClick={() => abrirPerfilEmpresa(recomendacion.id)}
                                // >
                                //     <CardActionArea>
                                //         <CardMedia
                                //             component='img'
                                //             alt={recomendacion.nombreEmpresa}
                                //             image={recomendacion.img}
                                //             title={recomendacion.nombreEmpresa}
                                //         />
                                //         <CardContent className='overflow-hidden text-dark'>
                                //             <p className='fs-4 overflow-hidden'>
                                //                 {recomendacion.nombreEmpresa}
                                //             </p>
                                //             <p className='fs-6 overflow-hidden'>
                                //                 {recomendacion.descripcionEmpresa}
                                //             </p>
                                //             <p className='fs-6 overflow-hidden'>
                                //                 {recomendacion.localidad.nombre} - {recomendacion.localidad.provincia.nombre}
                                //             </p>
                                //         </CardContent>
                                //     </CardActionArea>
                                // </Card>
                                // <div className="card-recomendados scale">
                                //     <div className='card-header'>
                                //         <img className='img-thumbnail img-fluid' src={recomendacion.img} alt={recomendacion.nombreEmpresa} />
                                //         <div className='card-cuerpo'> 
                                //             <p className='fs-4 overflow-hidden'>
                                //                 {recomendacion.nombreEmpresa}
                                //             </p>
                                //             <p className='card-texto'>
                                //                 {recomendacion.localidad.nombre} - {recomendacion.localidad.provincia.nombre}
                                //             </p>
                                //         </div>
                                //     </div>
                                //     <div className="card-pie">
                                //         <p className='card-descripcion fs-6 overflow-hidden'>
                                //             {recomendacion.descripcionEmpresa}
                                //         </p>
                                //         <span className='card-link'
                                //             onClick={() => abrirPerfilEmpresa(recomendacion.id)}
                                //         >
                                //             Ver más
                                //         </span>
                                //     </div>
                                // </div>
                                <div className="card_recomendados mx-auto"
                                    onClick={() => abrirPerfilEmpresa(recomendacion.id)}
                                >
                                    <img className='card_img' src={recomendacion.img} alt={recomendacion.nombreEmpresa} />
                                    <div className="card_pie">
                                        <p className='text-color text-about'>
                                            {recomendacion.nombreEmpresa}
                                        </p>
                                        <p className=''>
                                            {recomendacion.localidad.nombre} - {recomendacion.localidad.provincia.nombre}
                                        </p>
                                        <p className="card_descripcion">
                                            {recomendacion.descripcionEmpresa}
                                        </p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>

            {/* <section id='cta' className="callToAction">
                <div className="cta-container flex items-center">
                        <div className="col-lg-6 text-center">
                            <h3>¡Cuidatia te ofrece la mejor experiencia de cuidado!</h3>
                            <p>¡No esperes más!</p>
                        </div>
                        <div className='flex w-full justify-center'>
                            <div className="button">VER SERVICIOS</div>
                        </div>
                </div>
            </section> */}

            <section className="callToAction">
                    <div className="container-cta relative">
                        <div className="container-items flex flex-wrap">
                            <div className="text-center">
                                <span className="h3-about block mb-4 text-base font-medium text-white">
                                    ¿A qué esperas?
                                </span>
                                <h2 className="text-uppercase mb-6 text-3xl font-bold leading-tight text-white sm:mb-8 sm:text-[40px]/[48px] lg:mb-0">
                                    <span className="xs:block h2-about">¡COMIENZA A OFRECER TUS SERVICIOS!</span>
                                </h2>
                            </div>
                            <div className="px-4 lg:w-1/2 mt-2">
                                <div className="flex flex-wrap lg:justify-end">
                                    <div className="btn btn-cta btn-lg"
                                        onClick={() => {
                                            scroll.scrollToTop();
                                            navigate('/registroEmpresa')
                                        }}
                                    >
                                        ÚNETE AHORA
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <span className="absolute top-0 left-0 z-[-1]">
                                <svg
                                width="189"
                                height="162"
                                viewBox="0 0 189 162"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <ellipse
                                    cx="16"
                                    cy="-16.5"
                                    rx="173"
                                    ry="178.5"
                                    transform="rotate(180 16 -16.5)"
                                    fill="url(#paint0_linear)"
                                />
                                <defs>
                                    <linearGradient
                                    id="paint0_linear"
                                    x1="-157"
                                    y1="-107.754"
                                    x2="98.5011"
                                    y2="-106.425"
                                    gradientUnits="userSpaceOnUse"
                                    >
                                    <stop stop-color="white" stop-opacity="0.15" />
                                    <stop offset="1" stop-color="white" stop-opacity="0" />
                                    </linearGradient>
                                </defs>
                                </svg>
                            </span>
                            <span className="absolute bottom-0 right-0 z-[-1]">
                                <svg
                                width="191"
                                height="208"
                                viewBox="0 0 191 208"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <ellipse
                                    cx="173"
                                    cy="178.5"
                                    rx="173"
                                    ry="178.5"
                                    fill="url(#paint0_linear)"
                                />
                                <defs>
                                    <linearGradient
                                    id="paint0_linear"
                                    x1="-3.27832e-05"
                                    y1="87.2457"
                                    x2="255.501"
                                    y2="88.5747"
                                    gradientUnits="userSpaceOnUse"
                                    >
                                    <stop stop-color="white" stop-opacity="0.15" />
                                    <stop offset="1" stop-color="white" stop-opacity="0" />
                                    </linearGradient>
                                </defs>
                                </svg>
                            </span>
                        </div>
                    </div>
                </section>

            <section className='about'>
                {/* <div className="container">
                    <div className="section-title">
                        <h2>Nuestra historia</h2>
                        <br />
                        <p className='texto-metodo'>
                        <b>CUIDATIA</b> nace de la experiencia de más de <b>20 años</b> de la prestación de servicios domiciliarios a lo largo del todo el territorio nacional.
                        Durante más de 20 años hemos desarrollado servicios profesionales de ayuda a domicilio en cuidados domésticos, personales, peluquería, podología, fisioterapeuta, etc.
                        Superados los 10.000 clientes, hemos evolucionado y pasado a acercar los servicios online con la finalidad de facilitar la vida a la personas que nos necesitan.
                        Tras haber estudiado las necesidades de las personas y las empresas y tras haber comprobado las necesidades de la denominada “España despoblada” (o España Rural) en la dotación de servicios, nace CUIDATIA.
                        CUIDATIA es una plataforma capaz de llevar todos los servicios sociosanitarios y sanitarios, a los domicilios de las personas que lo necesiten y capaz de llevar los servicios profesionales a las zonas más rurales.
                        Ofrece al cliente la posibilidad de elegir entre recibir un servicio en el domicilio o en el centro profesional.
                        Asegura el desarrollo de los servicios profesionales, como garantía para el cliente y el desarrollo de la PYME como garantía de desarrollo rural.
                        Ofrece los mejores avances en tecnología para el cuidado de las personas y permite a las personas elegir por qué profesional quiere ser atendido, dónde, cuando y comparar precios.
                        Es decir disfrutar <b>LA EXPERIENCIA DE SER CUIDADO</b>.
                        </p>
                    </div>
                </div> */}
                <div className="container text-center">
                    <div className="titulo-pasos">
                        <h2 className='h2-about text-uppercase'>Nuestros planes</h2>
                    </div>
                    <div>
                        <p className='h3-about'>Elige tu plan y comienza a disfrutar de ventajas diseñadas pensando en ti.</p>
                    </div>
                    <div className="container w-75 d-flex res-planes justify-content-between">
                        <div className="card card-planes scale rounded-4 p-4 mt-3">
                            <h3 className='fw-bold'>Básico</h3>
                            <span className='fs-5'><strong>150€</strong> | Año</span>
                            <div className="btn btn-primary-hover rounded-pill my-4 px-2"
                                onClick={() => {
                                    scroll.scrollToTop();
                                    navigate('/club-cuidatia#pricing-table');
                                }}
                            >
                                Ver plan
                            </div>
                            <div className="card-content">
                                <ul className='list-caracteristicas border-top p-0 pt-2'>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>2 publicaciones de servicios/mes.</span>
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100 px-1'>Perfil básico.</span>
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Visibilidad mínima en los resultados de búsqueda.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="card card-planes scale rounded-4 p-4  mt-3">
                            <h3 className='fw-bold'>Premium</h3>
                            <span className='fs-5'><strong>950€</strong> | Año</span>
                            <div className="btn btn-primary-hover rounded-pill my-4 px-2"
                                onClick={() => {
                                    scroll.scrollToTop();
                                    navigate('/club-cuidatia#pricing-table');
                                }}
                            >
                                Ver plan
                            </div>
                            <div className="card-content">
                                <ul className='list-caracteristicas border-top p-0 pt-2'>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Mayor número de publicaciones.</span>
                                        
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Perfil detallado.</span>
                                        
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Mayor visibilidad en los resultados de búsqueda.</span>
                                        
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Otras.</span>
                                        
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="card card-planes scale rounded-4 p-4 mt-3 bg-destacado text-white">
                            <h3 className='fw-bold'>Todo Incluido</h3>
                            <span className='fs-5'><strong>2.000€</strong> | Año</span>
                            <div className="btn btn-destacado rounded-pill my-4 px-2"
                                onClick={() => {
                                    scroll.scrollToTop();
                                    navigate('/club-cuidatia#pricing-table');
                                }}
                            >
                                Ver plan
                            </div>
                            <div className="card-content">
                                <ul className='list-caracteristicas border-top p-0 pt-2'>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Publicaciones ilimitadas.</span>
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Perfil completo.</span>
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Visibilidad máxima en los resultados de búsqueda.</span>
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Modelo de Atención Centrada a la Persona.</span>
                                    </li>
                                    <li className='flex flex-nowrap align-items-center'>
                                        <span className="flex-shrink-1 w-1 h-1 text-gray-800 me-1">
                                            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                            </svg>
                                        </span>
                                        <span className='w-100'>Otras.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='mt-5 fs-5'>
                        <p className='text-about'>En Club Cuidatía, ofrecemos diferentes planes para adaptarnos a tus necesidades. Ya sea que busques servicios básicos o experiencias premium, cada plan está creado para brindarte comodidad, calidad y tranquilidad. Descubre las opciones y encuentra el cuidado perfecto para ti.</p>
                    </div>
                </div>
            </section>

            {/* <div id="cta" className="cta">
                <div className="cta-container">
                    <div className="row">
                        <div className="col-lg-12 text-center cba imgUnCafeRural">
                            <img src={tituloCafe}/>
                            <h1>¡El evento más esperado del año!</h1>
                            <h2>
                                <br /> 
                                ¡No te pierdas la oportunidad de descubrir cómo DehesaRural y Cuidatia <br /> están transformando 
                                el futuro de los servicios sociales en Extremadura!<br /> <br /> Ven a nuestros eventos en tu localidad,
                                <br /> 
                                conecta con soluciones innovadoras que mejoran la calidad de vida <br />y participa en el impulso 
                                de nuestras comunidades rurales.<br /> <br /> ¡Te esperamos para construir juntos el mañana!
                            </h2>
                        </div>
                        <div
                            className='button'
                            onClick={() =>{navigate('/un-cafe-rural')}}
                        >
                            <b>Inscríbete aquí</b>
                        </div>
                        
                    </div>
                </div>
            </div> */}
		</>
	);
};
